import {Typography} from "@mui/material";
import {theme} from "../../../../Tema";


export const IconoTexto = ({Icono, texto}) => {

    return (
        <Typography sx={{fontSize: 14, color: '#00000090'}}>
            <span><Icono sx={{fill: theme.palette.secondary.main, mt: 0.7, mb: -0.7, pr: 1}}/></span>
            {texto}
        </Typography>
    )
}